<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

import Store from '@/store'
import { TweenMax as Tween, TimelineMax as Line, Power1 } from 'gsap'
import find from 'lodash/find'
import groupBy from 'lodash/groupBy'

import TransitionWrapper from '@/layout/wrappers/transition-wrapper'
import AppearanceWrapper from '@/layout/wrappers/appearance-wrapper'
import ScrollMarker from '@/components/scroll-marker'
import * as Widgets from './widgets'
import TheFooter from '@/layout/the-footer'

export default {

  name: 'PostPage',

  components: {
    TransitionWrapper,
    AppearanceWrapper,
    ScrollMarker,
    ...Widgets,
    TheFooter
  },

  filters: {
    formatDate: (timestamp) => {
      const date = new Date(timestamp)
      const day = date.getDate().toString().length < 2 ? '0' + date.getDate() : date.getDate()
      const month = date.getMonth().toString().length < 2 ? '0' + date.getMonth() : date.getMonth()
      const year = date.getFullYear()

      return `${day} / ${month} / ${year}`
    }
  },

  data () {
    return {
      scrollVisible: false
    }
  },

  computed: {
    slug () {
      return this.$route.params.slug
    },

    type () {
      if (this.$route.name.match(/story/)) return 'story'
      if (this.$route.name.match(/project/)) return 'project'

      this.$route.redirect('404')
    },

    $content () {
      return this.$store.state.pages.inners[this.slug]
    },

    $widgets (){
      let array = [];

      return groupBy(this.$content.widgets, 'type');
    }
  },

  beforeRouteEnter: async (to, from, next) => {
    Store.commit('startLoading');
    console.log('beforeRouteEnter');


    const errors = [];
    const data = await Store.dispatch('pages/fetchInner', {url: to.path.split('/')[2] , name:to.params.slug});


    if(data.status === 404) errors.push(404);
    if (!data.title) errors.push('post must have a title');
    if (!data.pageMedia || !data.pageMedia.image) errors.push('post must have an image');
    if (to.name === 'project' && !find(data.widgets, { type: 'EntityDescription' })) errors.push('project must have an \'EntityDescription\' widget');


    Store.commit('endLoading');

    if (errors.length > 0) {
      console.log(to, from);

      if(errors[0] === 404){
        console.log(this)
        next({
          path: '/' + (from.params.lang || to.params.lang || 'ua') + '/error',
          query: {
            code: 404
          }
        });

      }
      else{
        next({
          path: '/' + (from.params.lang || to.params.lang || 'ua') + '/error',
          query: {
            code: 500,
            errors
          }
        })
      }

      return;
    }

    next();
  },

  beforeRouteUpdate: async (to, from, next) => {
    if (from.params.lang === to.params.lang) {
      next()
      return
    }

    Store.commit('startLoading');


    const errors = []
    const data = await Store.dispatch('pages/fetchInner', {url: to.path.split('/')[2] , name:to.params.slug})

    if(data.status === 404) errors.push(404);
    if (!data.title) errors.push('post must have a title')
    if (!data.pageMedia || !data.pageMedia.image) errors.push('post must have an image')
    if (to.name === 'project' && !find(data.widgets, { type: 'EntityDescription' })) errors.push('project must have an \'EntityDescription\' widget')



    Store.commit('endLoading')

    if (errors.length > 0) {
      console.log(to, from);

      if(errors[0] === 404){

        next({
          path: '/' + (from.params.lang || to.params.lang || 'ua') + '/error',
          query: {
            code: 404
          }
        })

      }
      else{

        next({
          path: '/' + (from.params.lang || to.params.lang || 'ua') + '/error',
          query: {
            code: 500,
            errors
          }
        })

      }

    }

    next()
  },

  created(){
    this.setTitle();
  },

  methods: {

    setTitle(){
      let title = document.getElementsByTagName('title')[0];
      return title.text = this.$content.meta.title;
    },

    enter (el, done) {
      const tl = new Line({ onComplete: () => done })
      const group = el.querySelectorAll('[data-item]')

      tl.from(group, 1, {
        autoAlpha: 0,
        y: -40,
        ease: Power1.easeOut
      })

      tl.set(this, {
        scrollVisible: true
      }, 0.6)

      tl.from(this.$refs.image, 0.5, {
        y: -20,
        autoAlpha: 0,
        ease: Power1.easeOut,
        // onUpdate: () => {
        //   if (!this.$refs.image) return

        //   const y = this.$refs.image.style.opacity * 100

        //   Tween.set(this.$refs.image, {
        //     clipPath: `polygon(0% 0%, 100% 0%, 100% ${y}%, 0% ${y}%)`
        //   })
        // },
        onComplete () {
          if (this.target) this.target.removeAttribute('style')
        }
      }, '+=0.6')

      // tl.from(this.$refs.image, 1, {
      //   autoAlpha: 0,
      //   ease: Power1.easeIn
      // }, '+=0.6')
    },

    leave (el, done) {
      if (this.$store.state.app.routeChangedFromPopup) {
        done()
      } else {
        Tween.to(el, 0.5, {
          autoAlpha: 0,
          ease: Power1.easeOut,
          onComplete: done
        })
      }
    },

    scroll () {
      // const bb = this.$refs.description.$el.getBoundingClientRect()

      // const offset = bb.top - ((this.$store.state.app.window.height - bb.height) / 2)
      // const scroll = this.$store.state.app.window.scroll + offset
      const scroll = this.$store.state.app.window.height;

      Tween.to(window, 1, {
        scrollTo: scroll,
        ease: Power1.easeInOut
      })
    },

    getWidgetType (type) {
      switch (type) {
        case 'EntityDescription': return 'ProjectDescription';
        case 'Text': return 'TextCommon';
        case 'Accent': return 'TextAccent';
        case 'Aside': return 'TextAside';
        default: return type
      }
    },

    validateWidget (widget) {

      let errors = [];
      if (widget.type === 'Accent') errors = this.checkWidgetFields(widget, 'title', 'content');
      if (widget.type === 'Aside') errors = this.checkWidgetFields(widget, 'title', 'description', 'media');
      if (widget.type === 'Media') errors = this.checkWidgetFields(widget, 'title', 'description', 'media');
      if (widget.type === 'Player') errors = this.checkWidgetFields(widget, 'poster', 'media');
      if (widget.type === 'EntityDescription') errors = this.checkWidgetFields(widget, 'entityType', 'year', 'client')
      if (widget.type === 'Slider') errors = this.checkWidgetFields(widget, 'items')
      if (widget.type === 'Text') errors = this.checkWidgetFields(widget, 'content')

      if (errors.length <= 0) return true

      errors.forEach(error => console.warn(error))

    },

    checkWidgetFields (widget, ...fields) {
      const errors = []

      if (widget.type === 'EntityDescription') {
        if (!widget.entityType) errors.push(`${widget.type} widget must have a field: "entityType"`)
        if (!widget.year) errors.push(`${widget.type} widget must have a field: "year"`)
        if (!widget.client) errors.push(`${widget.type} widget must have a field: "client"`)
      }

      return fields.reduce((errors, field) => {
        if (!widget.hasOwnProperty(field) || widget[field].length <= 0) errors.push(`${widget.type} widget must have a field: "${field}"`)
        return errors
      }, errors)
    }
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

article.page
  header.intro
    .intro__content
      .intro__time(v-if="type === 'story'" data-item) {{ $content.createdAt | formatDate }}
      .intro__title(data-item) {{ $content.title }}
      .intro__description(v-if="$content.description" data-item) {{ $content.description }}
      transition-wrapper(:appear="true")
        scroll-marker.intro__scroll(v-if="scrollVisible", @click="scroll", :dark-mode="true")
    .intro__image(ref="image"): img(:src="$content.pageMedia.image.url" alt="image")

  main.main
    template(v-for="widget in $content.widgets")
      appearance-wrapper(v-if="validateWidget(widget)")
        component(
          :key="widget.id",
          :is="getWidgetType(widget.type)",
          :content="widget")

  appearance-wrapper
    the-footer

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>

.intro
  display flex
  flex-direction column
  align-items center

  &__content
    position relative
    display flex
    flex-direction column
    max-width 940px
    width 100%
    padding 200px 24px 150px
    +mobile()
      padding: 100px 24px;

  &__time
    padding-bottom 37px
    font-weight 400
    font-size 12px
    line-height 20px
    color light

  &__title
    font-weight 400
    font-size 56px
    line-height 57px
    color blue
    +tablet()
      font-size 46px
      line-height 50px
    +mobile()
      font-size 34px
      line-height 37px

  &__description
    padding-top 21px
    font-weight 300
    font-size 26px
    line-height 34px
    color dark
    +mobile()
      font-size 17px
      line-height 21px

  &__scroll
    position absolute
    left 0
    right 0
    bottom 0
    margin 0 auto

  &__image
    position relative
    width 100%
    height 48vw
    max-height 84.6vw
    overflow hidden
    transform-origin top

    img
      position absolute
      top 0
      left 0
      width 100%
      height 100%
      object-fit cover

.main .widget:last-child
  padding-bottom 0 !important

//layout for widgets
.main
  .widget
    word-break: break-word;

</style>



// WEBPACK FOOTER //
// index.vue?77c7b396